import { motion } from 'motion/react';

import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import styles from './Message.module.css';

import circle from '../../assets/video/circle3.webm';

const Message = ({ message, authorFontSize, currentState, winId }) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  const isWinner = currentState === 'S6';

  return (
    <div className={styles.wrapper}>
      {message && (
        <motion.div
          animate={{ opacity: isWinner && winId !== message.id ? 0 : 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className={styles.blockMsg}
        >
          <div className={styles.avatar}>
            <div
              className={styles.avatarBg}
              style={{
                background: `url(${
                  iconsSources[message?.channel]
                }) center/cover no-repeat `,
              }}
            />
            <img
              src={
                (message?.image !== '1' && message?.image) ||
                iconsSources[message?.channel]
              }
              alt={message?.author}
              onError={errorHandler}
            />
            <div className={styles.bodrerImg} />

            {isWinner && winId === message.id && (
              <motion.video
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.5 }}
                muted="muted"
                loop
                playsInline
                autoPlay
                className={styles.circle}
              >
                <source src={circle} type="video/webm" />
              </motion.video>
            )}
          </div>
          <div
            className={styles.nameAuthor}
            style={{ fontSize: `${authorFontSize}rem` }}
          >
            {message?.author || hideNumber(message?.senderNumber)}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default Message;
